import type {
  SurveyAnswerFlattenedValue,
  SurveyElementJson,
  SurveyImageAnswerValue,
} from '../types'

// 型マッピングを定義
type SurveyAnswerTypeMap = {
  radiogroup: string
  checkbox: string[]
  boolean: boolean
  ranking: string[]
  imagepicker: string | string[]
  file: SurveyImageAnswerValue[]
  dropdown: string
}

// サポートされている質問タイプ
const SUPPORTED_QUESTION_TYPES = new Set<keyof SurveyAnswerTypeMap>([
  'radiogroup',
  'checkbox',
  'boolean',
  'ranking',
  'imagepicker',
  'file',
  'dropdown',
])

// 条件型 + 実行時チェック
export function getTypedAnswerValue<T extends SurveyElementJson>(
  question: T,
  answerValue: SurveyAnswerFlattenedValue | undefined,
): T['type'] extends keyof SurveyAnswerTypeMap
  ? SurveyAnswerTypeMap[T['type']] | undefined
  : never {
  if (answerValue === undefined) {
    return undefined as any
  }

  // 実行時サポートチェック
  if (!SUPPORTED_QUESTION_TYPES.has(question.type as keyof SurveyAnswerTypeMap)) {
    throw new Error(`Not implemented question type: ${question.type}`)
  }

  return answerValue as any
}

export function getTypedAnswerCommentValue(
  answerValue: SurveyAnswerFlattenedValue | undefined,
) {
  if (answerValue === undefined) {
    return undefined
  }

  return answerValue as string
}
